import { render } from "./CreateHoldFromLandownerSideModal.vue?vue&type=template&id=da9a6aea&scoped=true&ts=true&lang=pug"
import script from "./CreateHoldFromLandownerSideModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateHoldFromLandownerSideModal.vue?vue&type=script&lang=ts&setup=true"

import "./CreateHoldFromLandownerSideModal.vue?vue&type=style&index=0&id=da9a6aea&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da9a6aea"]])

export default __exports__